import { format } from 'svelte-i18n';
import BlindTime from '../Steps/BlindTime.svelte';
import DevicePicker from '../Steps/DevicePicker.svelte';
import QuickActions from '../Steps/QuickActions.svelte';
import DeviceTypePicker from '../Steps/DeviceTypePicker.svelte';
import { get } from 'svelte/store';
import { capFirstChar } from 'src/helpers/utilities';

export const motionTemplate = (disabled, deviceActions, _, index) => {
	return [
		{
			active: index === 0,
			activeIndex: 0,
			disabled: disabled,
			showMoreDots: false,
			stepNumber: 1,
			title: capFirstChar(
				get(format)('text_list_device_info_type', {
					default: 'Device type',
				}),
			),
			tooltipTitle: '',
			component: DeviceTypePicker,
			validation: false,
		},
		{
			active: index === 1,
			activeIndex: 1,
			disabled: disabled,
			showMoreDots: false,
			stepNumber: 2,
			title: get(format)('devices', { default: 'Devices' }),
			tooltipTitle: '',
			component: DevicePicker,
			validation: deviceActions?.type === undefined,
		},
		{
			active: index === 2,
			activeIndex: 2,
			disabled: disabled,
			showMoreDots: false,
			stepNumber: 3,
			title: get(format)('blind_time', { default: 'Blind time' }),
			tooltipTitle: '',
			component: BlindTime,
			validation: deviceActions.selectedDevices.length === 0,
		},
		{
			active: index === 3,
			activeIndex: 3,
			component: QuickActions,
			disabled: deviceActions.disabled,
			showMoreDots: false,
			stepNumber: 4,
			title: get(format)('actions', { default: 'Actions' }),
			tooltipTitle: '',
			validation: deviceActions.selectedDevices.length === 0,
		},
	];
};
